import React, { ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'
import { tv } from 'tailwind-variants'

interface SectionContentProps {
  children: ReactNode
  className?: string
  offset?: boolean
  theme?: 'light' | 'dark'
  stickOnBorder?: boolean
}

const sectionContentStyles = tv({
  base: 'flex flex-col ltr:md:pr-0 rtl:md:pl-0 rtl:pr-sidebar-mobile rtl:md:pr-sidebar-desktop ',
  variants: {
    offset: {
      false: 'ltr:pl-sidebar-mobile ltr:md:pl-sidebar-desktop',
      true: '',
    },
    theme: {
      light: 'text-black',
      dark: 'text-white',
    },
    stickOnBorder: {
      true: 'md:ml-spacing-xl ',
      false: 'md:mx-spacing-xl ltr:pr-[32px] rtl:pl-[32px]',
    },
  },
})

const SectionContent: React.FC<SectionContentProps> = ({
  children,
  className = '',
  offset = false,
  theme = 'light',
  stickOnBorder = false,
}) => {
  return (
    <div
      className={twMerge(
        sectionContentStyles({ offset, theme, stickOnBorder }),
        className || '',
      )}
    >
      {children}
    </div>
  )
}

export default SectionContent
